import duesConstants from "../constants/duesConstants";

// eslint-disable-next-line import/prefer-default-export
export const getClientDues = (payload: any) => ({
  type: duesConstants.GET_CLIENT_DUES_REQUEST,
  payload,
});

export const getInvoiceDues = (payload: any) => ({
  type: duesConstants.GET_INVOICE_DUES_REQUEST,
  payload,
});

export const resetDues = () => ({
  type: duesConstants.RESET_DUES,
});
